import React from 'react';

import Container from './Container';
import BottomMessage from './BottomMessage';
import TitleIcon from './TitleIcon';

export default ({ verification_denial_reason, verification_failure_message }) =>
  ({
    must_complete_sale: (
      <Container>
        <TitleIcon name="truck" />
        <div>The verification process will begin when you complete your first sale.</div>
      </Container>
    ),
    starting_soon: (
      <Container>
        <TitleIcon name="check" />
        <div>Verification process starting soon.</div>
      </Container>
    ),
    failed_plaid_error: (
      <Container error>
        <TitleIcon name="bell" />
        <div>Unknown plaid error. Please contact us. (Code: E101)</div>
        <BottomMessage>Please try changing to a different account.</BottomMessage>
      </Container>
    ),
    failed_process_error: (
      <Container error>
        <TitleIcon name="bell" />
        <div>Verification process failed, please contact us. (Code: E102)</div>
        <BottomMessage>Please try changing to a different account.</BottomMessage>
      </Container>
    ),
    failed_too_many_attempts: (
      <Container error>
        <TitleIcon name="bell" />
        <div>Too many attempts, please contact us. (Code: E103)</div>
        <BottomMessage>Please try changing to a different account.</BottomMessage>
      </Container>
    ),
    failed_unknown: (
      <Container error>
        <TitleIcon name="bell" />
        <div>Unknown error. Please contact us. (Code: E104)</div>
        <BottomMessage>Please try changing to a different account.</BottomMessage>
      </Container>
    ),
  }[verification_denial_reason] || (
    <Container error>
      <TitleIcon name="bell" />
      <div>{verification_failure_message}</div>
      <BottomMessage>Please try changing to a different account.</BottomMessage>
    </Container>
  ));
